module.exports = __webpack_public_path__ + "static/img/self-sufficient.d13f6b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/innovations/self-sufficient.png
// module id = QIKX
// module chunks = 1